import { FetchImageCropsSortTypes } from './imageCropsTypes';

export const INITIAL_IMAGE_CROPS_FILTERS = {};
export const INITIAL_IMAGE_CROPS_PAGE = 1;
export const INITIAL_IMAGE_CROPS_SORT = [
  FetchImageCropsSortTypes.CREATED_AT_DESC
];
export const INITIAL_IMAGE_CROPS_LIMIT = 50;
